import React from 'react';
import { SectionManagementForm } from './SectionManagementForm';
import { Section } from '../../../store/sections/types';
import { useDispatch, useSelector } from 'react-redux';
import { SectionListRoute } from '../../../routes/routes';
import { postSection } from '../../../store/sections/actions';
import { useHistory } from 'react-router';
import { ISectionsState } from '../../../store/sections/store';
import { StoreState } from '../../../store/store';
import { useToast } from '../../../hooks/useToast';

export const SectionManagementAddForm: React.FunctionComponent<{}> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { addToast } = useToast();

  const sectionsState = useSelector<StoreState, ISectionsState>(
    (state) => state.sections
  );

  const enableActionButtonCondition = (newSection: Section): boolean => {
    if (newSection.industry === '' || newSection.portalName === '') return true;
    if (
      newSection.webSectionName === '' ||
      newSection.webSectionDisplayName === '' ||
      //newSection.webSectionURL === '' ||
      //newSection.powerBIReportName === '' ||
      //newSection.powerBIReportDefaultPage === '' ||
      newSection.userWebFeatureGrant === '' ||
      newSection.webSectionDisplayName === ''
    )
      return true;
    return false;
  };

  const showErrorToast = (message: string) => {
    addToast({
      status: 'danger',
      message: message,
      datetime: Date.now(),
    });
  };

  const addSectionClick = async (newSection: Section) => {
    const hasErrors = validateEdit(newSection);
    if (hasErrors === false) {
      dispatch(postSection(newSection));
      history.push(SectionListRoute.path);
    }
  };

  const validateEdit = (section: Section) => {
    let hasErrors = false;

    // webSectionName
    const duplicatedWebSectionName =
      sectionsState.sections.find(
        (x) =>
          x.industry === section.industry &&
          x.portalName === section.portalName &&
          x.webSectionName === section.webSectionName
      ) !== undefined;
    if (duplicatedWebSectionName) {
      hasErrors = true;
      showErrorToast(
        `Web Section Name ${section.webSectionName} is already in use`
      );
    }

    // webSectionURL
    if (section.webSectionURL !== '') {
      const duplicatedURL =
        sectionsState.sections.find(
          (x) => x.webSectionURL === section.webSectionURL
        ) !== undefined;
      if (duplicatedURL) {
        hasErrors = true;
        showErrorToast(
          `Web Section URL ${section.webSectionURL} is already in use in section ${section.webSectionName}`
        );
      }
    }

  //   // report name
  //   if(section.powerBIReportName !== ''){
  //   const duplicatedReportName =
  //     sectionsState.sections.find(
  //       (x) => x.powerBIReportName === section.powerBIReportName
  //     ) !== undefined;
  //   if (duplicatedReportName) {
  //     hasErrors = true;
  //     showErrorToast(
  //       `PowerBI report ${section.powerBIReportName} is already in use in section ${section.webSectionName}`
  //     );
  //   }
  // }

    // userWebFeatureGrant
    const duplicatedWebFeatureGrant =
      sectionsState.sections.find(
        (x) => x.userWebFeatureGrant === section.userWebFeatureGrant
      ) !== undefined;
    if (duplicatedWebFeatureGrant) {
      hasErrors = true;
      showErrorToast(
        `Web Feature Grant ${section.userWebFeatureGrant} is already in use in section ${section.webSectionName}`
      );
    }
  

    return hasErrors;
  };

  return (
    <SectionManagementForm
      actionButtonClick={addSectionClick}
      actionButtonText="Add section"
      editMode={false}
      enableActionButtonCondition={enableActionButtonCondition}
    />
  );
};
